import { findWhere as findWhere2 } from 'underscore';

export const findWhere = (collection, key, value) => {
    return findWhere2(collection, { [key]: value });
};

export default findWhere;
